(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-youtube-video-cover"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pdp-youtube-video-cover')) {
    class PdpYoutubeVideoCover extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.button = this.querySelector('.pdp-yt-cover__play');
        this.iframe = this.querySelector('.pdp-yt-cover__iframe');

        if (!this.button || !this.iframe || !this.iframe.dataset.src) return;

        this.initialized = true;
        this.restoreOnPause = this.dataset.restoreOnPause === 'true';
        this.playerOrigin = new URL(this.iframe.dataset.src).origin;

        this.button.addEventListener('click', () => this.play());
        this.iframe.addEventListener('load', () => this.startListening());
        window.addEventListener('message', (event) => this.handleMessage(event));
      }

      play() {
        this.iframe.src = this.iframe.dataset.src;
        this.iframe.hidden = false;
        this.classList.add('is-playing');
        this.iframe.focus({ preventScroll: true });
      }

      restoreCover() {
        this.classList.remove('is-playing');
        this.iframe.hidden = true;
        this.iframe.removeAttribute('src');
        this.button.focus({ preventScroll: true });
      }

      startListening() {
        if (!this.iframe.getAttribute('src')) return;

        this.iframe.contentWindow.postMessage(
          JSON.stringify({ event: 'listening', id: 1, channel: 'widget' }),
          this.playerOrigin
        );
      }

      handleMessage(event) {
        if (event.origin !== this.playerOrigin) return;
        if (event.source !== this.iframe.contentWindow) return;

        let payload;

        try {
          payload = JSON.parse(event.data);
        } catch (error) {
          return;
        }

        if (payload.event !== 'onStateChange' && payload.event !== 'infoDelivery') return;

        const state = typeof payload.info === 'number' ? payload.info : payload.info && payload.info.playerState;

        if (typeof state !== 'number') return;

        if (state === 0 || (state === 2 && this.restoreOnPause)) {
          this.restoreCover();
        }
      }
    }

    customElements.define('pdp-youtube-video-cover', PdpYoutubeVideoCover);
  }
  } catch(e) { console.error(e); }
})();

})();
